<template>
  <div :class="$style.breadcrumbs">
    <div :class="$style.path">
      <!--<router-link to="/" class="text-muted">Home</router-link>-->
      <template v-for="(item, index) in breadcrumb">
        <!--<span v-if="index != 0" :key="index">-->
        <router-link :to="{ path: item.url }" :key="index">
          <span
            v-if="item.title != 'Home'"
            :class="$style.arrow"
            class="text-muted"
          ></span>
          <strong class="text-muted font-weight-normal">{{
            item.title
          }}</strong>
        </router-link>
        <!--</span>-->
      </template>
      <span v-if="activeItem">
        <span :class="$style.arrow"></span>
        <strong>{{ activeItem.title }}</strong>
      </span>
    </div>
  </div>
</template>

<script>
import { getLeftMenuData, getTopMenuData } from "@/services/menu";
import { reduce } from "lodash";

export default {
  name: "breadcrumbs",
  data() {
    return {
      breadcrumb: [],
      activeItem: {},
      path: []
    };
  },
  props: {
    settings: Object
  },
  computed: {
    menuData() {
      return this.settings.isMenuTop ? getTopMenuData : getLeftMenuData;
    }
  },
  methods: {
    getPath() {
      let bItems = new Array();
      let i = 0;
      const segments = this.$route.matched.length;
      let rest, crumb, breadcrumbName;
      const id = this.$route.params.id;
      this.$route.matched.forEach((item, index) => {
        breadcrumbName = item.meta.breadcrumbName;
        if (typeof breadcrumbName !== "undefined" && breadcrumbName != "") {
          if (breadcrumbName === "Home") {
            crumb = {
              title: breadcrumbName,
              url: `/${item.redirect}`
            };
          } else if (breadcrumbName.indexOf(":id") > -1) {
            rest = breadcrumbName.replace(":id", "");
            crumb = {
              title: `#${id}${rest}`,
              url: item.path
            };
          } else {
            crumb = {
              title: breadcrumbName,
              url: item.path
            };
          }
          bItems[i++] = crumb;
        }
      });
      return bItems;
    }
  },
  mounted: function() {
    //this.breadcrumb = this.getPath(this.menuData, this.$route.path);
    this.breadcrumb = this.getPath();
    this.activeItem = this.breadcrumb.pop();
  },
  watch: {
    $route(to) {
      //this.breadcrumb = this.getPath(this.menuData, to.path);
      this.breadcrumb = this.getPath();
      this.activeItem = this.breadcrumb.pop();
    }
  }
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
